module.exports = __webpack_public_path__ + "img/enquiry.c0f4e0b8.svg";